
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[rootCategorySlug]/[subCategorySlug]",
      function () {
        return require("private-next-pages/category/[rootCategorySlug]/[subCategorySlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[rootCategorySlug]/[subCategorySlug]"])
      });
    }
  